import { useEffect, useState } from 'react';
import { FeatureSectionContent } from '@/utils/types/by-law';

export function useSectionContent(section: string) {
  const [content, setContent] = useState<FeatureSectionContent | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`/api/section?section=${section}`);
        if (!response.ok) throw new Error('Failed to fetch content');
        const data = await response.json();
        setContent(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch content'));
      }
    };

    fetchContent();
  }, [section]);

  return { content, error };
}